import { render, staticRenderFns } from "./IfTeamRep.vue?vue&type=template&id=1e239ec4&"
import script from "./IfTeamRep.vue?vue&type=script&lang=js&"
export * from "./IfTeamRep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports